import { useMemo } from "react";
import { useQuery } from "@apollo/client";
import { useAuth } from "components/Auth";
import { PROVIDER_ADDRESS_QUERY } from "./queries";

export function useProviderAddresses(providerId?: number) {
    const { effectiveProviderData } = useAuth();
    const resolvedProviderId = providerId ?? effectiveProviderData?.providerId;
    const queryResponse = useQuery(PROVIDER_ADDRESS_QUERY, {
            fetchPolicy: 'cache-first',
            variables: {
                providerId: resolvedProviderId!
            },
            skip: !resolvedProviderId,
        });

    const { addresses, mailingAddresses } = queryResponse?.data?.provider?.contactInfo ?? {};
    const providerAddresses = useMemo(() => [ ...(addresses || []), ...(mailingAddresses || []) ], [addresses?.length, mailingAddresses?.length]);
    
    return { ...queryResponse, providerAddresses };
}
